import getB4AList from "./getB4AList";
import getB4A from "./getB4A";

export default { getB4AList, getB4A };
